import axiosInstance from '../utils/AxiosConfig';

// Los errores del asistente (clave faltante, límite de preguntas, proveedor caído) traen un mensaje pensado para mostrarse:
// la pantalla los muestra en el chat, no como una falla general. `skipGlobalErrorRedirect` evita que un 403 saque a la
// persona de la pantalla.
const options = { skipGlobalErrorRedirect: true };

export const getAssistantStatus = async () => {
  const response = await axiosInstance.get('/assistant/status', options);
  return response.data?.data || { configured: false };
};

export const getAssistantSettings = async () => {
  const response = await axiosInstance.get('/assistant/settings', options);
  return response.data?.data || { configured: false, providers: [] };
};

export const saveAssistantSettings = async ({ provider, model, apiKey }) => {
  const body = {};
  if (provider) body.provider = provider;
  // '' quiere decir "usar el modelo por defecto"; undefined, "no cambiarlo".
  if (model !== undefined) body.model = model;
  if (apiKey) body.apiKey = apiKey;
  const response = await axiosInstance.put('/assistant/settings', body, { ...options, timeout: 90000 });
  return response.data?.data;
};

// Los modelos que el proveedor le ofrece a la clave: la que se está por guardar o, si no se manda, la ya guardada.
export const listAssistantModels = async ({ provider, apiKey }) => {
  const body = {};
  if (provider) body.provider = provider;
  if (apiKey) body.apiKey = apiKey;
  const response = await axiosInstance.post('/assistant/models', body, { ...options, timeout: 40000 });
  return response.data?.data?.models || [];
};

export const deleteAssistantSettings = async () => {
  const response = await axiosInstance.delete('/assistant/settings', options);
  return response.data?.data;
};

export const askAssistant = async ({ question, history, conversationId, signal }) => {
  const response = await axiosInstance.post(
    '/assistant/ask',
    { question, history, conversationId },
    { ...options, timeout: 200000, signal },
  );
  return response.data?.data;
};

// Los chats de la persona: lista, uno completo para retomarlo, y ocultar uno de la lista (el historial no se borra).
export const listAssistantConversations = async () => {
  const response = await axiosInstance.get('/assistant/conversations', options);
  return response.data?.data?.conversations || [];
};

export const getAssistantConversation = async (id) => {
  const response = await axiosInstance.get(`/assistant/conversations/${id}`, options);
  return response.data?.data?.messages || [];
};

export const hideAssistantConversation = async (id) => {
  await axiosInstance.delete(`/assistant/conversations/${id}`, options);
};

/** El tipo de error que manda el backend (`INVALID_KEY`, `PROVIDER_UNAVAILABLE`...), o `CANCELED` si la persona canceló. */
export const assistantErrorKind = (error) =>
  (error?.code === 'ERR_CANCELED' ? 'CANCELED' : error?.response?.data?.error_kind) || null;

export const assistantErrorMessage = (error) =>
  error?.response?.data?.error_message
  || error?.response?.data?.error_messages?.[0]
  || (error?.code === 'ECONNABORTED' ? 'La respuesta tardó demasiado. Probá con una pregunta más específica.' : null)
  || 'No se pudo completar la consulta. Probá de nuevo.';
